module.exports = __webpack_public_path__ + "5ef17b2e2f89d5d559b9c5f0c3e978b9.svg";